// @ts-nocheck

import router from './router';
import store from './store';
import {is_weixin} from './utils/weixin';
import versionTood from '@/utils/versionUpdate'

router.beforeEach(async (to, from, next) => {
  versionTood.isNewVersion()

  if (to && to.meta.title) {
    document.title = to.meta.title;
  }

  // 基本信息
  await store.dispatch('settings/setSetting');

  // 微信分享
  // await is_weixin();

  next();

});
